export const FileIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3777_4264)">
      <path d="M13.333 5.31738V14.667H3.33301V1.33301H9.22266L13.333 5.31738ZM4.66699 13.333H12V6.66699H8V2.66699H4.66699V13.333ZM9.33301 5.33301H11.4336L9.33301 3.29688V5.33301Z" />
    </g>
    <defs>
      <clipPath id="clip0_3777_4264">
        <rect width="16" height="16" />
      </clipPath>
    </defs>
  </svg>
);
